import moment from 'moment-jalaali'
import {mean} from 'lodash'

export function convertYearToJalali (gregorianYear) {
  return parseInt(moment(gregorianYear, 'YYYY').format('jYYYY'), 10)
}

export function matchableDates (gregorianYear, jalaliYear) {
  let minumumJalali = parseInt(moment(gregorianYear, 'YYYY').format('jYYYY'), 10)
  return (parseInt(jalaliYear, 10) === minumumJalali) || (jalaliYear === (minumumJalali + 1))
}

export function convertYearToGregorian (jalaliYear) {
  return parseInt(moment(jalaliYear, 'jYYYY').format('YYYY'), 10)
}

export function convertToGregorian (jalaliDate = '') {
  if (!jalaliDate) {
    return ''
  }
  if (typeof jalaliDate === 'object') {
    return jalaliDate.format('YYYY-MM-DD')
  }
  return moment(jalaliDate, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
}

export function convertToJalali (gregorianDate = '', format = 'jYYYY-jMM-jDD') {
  if (!gregorianDate) {
    return ''
  }
  moment.loadPersian()
  return moment(gregorianDate, 'YYYY-MM-DD').format(format)
}

export function timeAgo (datetime) {
  moment.loadPersian()
  return moment(datetime).fromNow()
}

export function applyLimitation (value, min1, max1, min2, max2) {
  const valueString = value + ''
  if (valueString.length !== 4) { return value }
  const meanValue = mean([max1, min2])
  if (value <= min1) { return min1 }
  if (value >= max2) { return max2 }

  if (value > max1 && value < min2) { // limbo
    if (value <= meanValue) { return max1 } else { return min1 }
  }
  return value
}



// WEBPACK FOOTER //
// ./src/utils/dateHelper.js